/**
 * 建筑信息编辑
 */
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber, Select } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import validator from '../../../util/validator';

const fields = [{
    "text": "所属建筑",
    "field": "buildingId",
    "building": true,
    rules: [
        { required: true, message: '所属建筑不能为空!' },
    ]
}, {
    "text": "楼层编码",
    "field": "floorCode",
    rules: [
        { required: true, message: '楼层编码不能为空!' },
        { max: 16, message: '楼层编码不能超过16个字符！' },
        validator.lineEnNum
    ]
}, {
    "text": "楼层名称",
    "field": "floorName",
    rules: [
        { required: true, message: '楼层名称不能为空!' },
        { max: 32, message: '楼层名称不能超过32个字符！' },
    ]
}, {
    "text": "楼层面积",
    "field": "area",
    "disabled": true,
}, {
    "text": "顺序",
    "field": "sequence",
    "number": true,
    rules: [
        { required: true, message: '顺序不能为空!' },
    ]
}];


class FloorEditForm extends Component {

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }

            http.post({
                url: '/floor/saveFloor',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    createDom = (fields) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < fields.length; i++) {
            let item = fields[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: item.building ? (editData[item.field] == null ? "" : editData[item.field] + "") : editData[item.field],
                        })(
                            item.number ?
                                <InputNumber precision={0} min={1} max={99} style={{ width: '100%' }} />
                                : item.building ? <Select >
                                    {this.props.buildingList.map((item, index) => {
                                        return <Select.Option key={item.id}>{item.buildingName}</Select.Option>
                                    })}
                                </Select>
                                    : <Input disabled={item.disabled} />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                width={500}
                title="楼层信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields(); }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const FloorEdit = Form.create()(FloorEditForm);

export default FloorEdit;